var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.description,
          expression: "description"
        }
      ],
      staticClass:
        "col-6 col-sm-3 badge-container text-center d-flex flex-column align-items-center"
    },
    [
      _c(
        "a",
        {
          staticClass: "badge-icon d-block w-100",
          attrs: { href: "/badge/" + _vm.badge.badge_alias + "/" }
        },
        [
          _c("img", {
            staticClass: "img-fluid badge-img",
            class: { "badge-gray": !_vm.badge.unlocked },
            attrs: { src: _vm.iconUrl }
          })
        ]
      ),
      _c("figcaption", { staticClass: "badge-name pt-2" }, [
        _vm._v(" " + _vm._s(_vm.name) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }